import React from "react";
import ReactDom from "react-dom";
import PropTypes from "prop-types";

function PortalModal({ children, onClose, open }) {
  if (!open) return null;

  return ReactDom.createPortal(
    <>
      <div
        role="button"
        tabIndex="0"
        className="portal-overlay"
        onClick={onClose}
        onKeyDown={onClose}
        aria-label="Close Overlay"
      />
      <div className="portal-modal">{children}</div>
    </>,
    document.getElementById("portal"),
  );
}

PortalModal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
};

export default PortalModal;
